import { ParsedUrlQuery } from "querystring";
import getConfig from "next/config";
import { ProductListingData } from "@/types/productListing";

const { publicRuntimeConfig } = getConfig();

export const loadChunkViaApiRoute = async (
  routerQuery: ParsedUrlQuery,
  chunk: number,
): Promise<ProductListingData> => {
  const { facetId, ...restOfQuery } = routerQuery;

  const formattedFacetId = Array.isArray(facetId)
    ? "/" + facetId.join("/")
    : facetId;

  const requestParams = new URLSearchParams({
    ...restOfQuery,
    chunk: String(chunk),
    ...(formattedFacetId ? { facetId: formattedFacetId } : {}),
  });

  const response = await fetch(
    `/${publicRuntimeConfig.applicationPrefix}/api/product-chunk?${requestParams.toString()}`,
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return await response.json();
};
